import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import G from '../assets/G.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import laurels from '../assets/laurels.png';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';
import zizon from '../assets/zizon.PNG';
import chilis from '../assets/chilis.PNG'
import about from '../assets/about.PNG';
import about1 from '../assets/about1.png';
import about12 from '../assets/about12.png';
import sale from '../assets/sale.png';
import twitter from '../assets/twitter.png';
import aboutmore from '../assets/about2.png';
import soup from '../assets/soup.png';
import soup2 from '../assets/soup2.png';
import soup3 from '../assets/soup3.png';
import soup4 from '../assets/soup4.png';
import soup5 from '../assets/soup5.png';
import noodle from '../assets/noodle.png';
import combo from '../assets/combo.png';
import crab from '../assets/crab.png';
import shrimp from '../assets/shrimp.png';
import visual1 from '../assets/mainvisual.png';
import visual2 from '../assets/mainvisual2.png';
import interior from '../assets/interior.png';
import interior2 from '../assets/interior2.png';
import interior4 from '../assets/interior4.png';
import interior5 from '../assets/interior5.png';
import interior6 from '../assets/interior6.png';
import interior7 from '../assets/interior7.png';
import chili from '../assets/chili.png';
import nood from '../assets/nood.png';
import mussle from '../assets/mussle.png';
import recycle from '../assets/recycle.png';
import noop from '../assets/noop.png';
import chili2 from '../assets/chiliiii.png';
import pinky from '../assets/pinkypromise.png';
import map from '../assets/map.png'
import business from '../assets/business.png';
import mashita from '../assets/mashita.png';

export default {
  mashita,
  business,
  map,
  noop,
  chili2,
  pinky,
  chili,
  nood,
  mussle,
  recycle,
  interior,
  interior2,
  interior4,
  interior5,
  interior6,
  interior7,
  visual1,
  visual2,
  soup,
  soup2,
  soup3,
  soup4,
  soup5,
  noodle,
  combo,
  shrimp,
  crab,
  aboutmore,
  twitter,
  sale,
  about,
  about1,
  about12,
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
  zizon,
  chilis,
};
